import {Card} from "../../Card";
import {VideoPokerHand} from "./VideoPokerHand";

export class VideoPokerInfoForClient {
    constructor(public videoPokerHand: VideoPokerHand,
                public changeDone: boolean,
                public doubleUpCards: Array<Card>,
                public playerActionsFinished: boolean,
                public totalBet: number, public totalPotentialWin: number, public totalWin: number) {

    }
}



// WEBPACK FOOTER //
// ./src/app/api/serverResponseClasses/VideoPokerInfoForClient.ts